import { useState } from "react";
import { C } from "../lib/constants";
import { normalizeMode } from "../lib/helpers";
import { Btn } from "./ui/Btn";

const getUserDisplayName = (user, profile) => {
  const raw = profile?.nombre || profile?.name || user?.email || "";
  return String(raw).trim().split(" ").filter(Boolean).slice(0,2).join(" ") || "";
};

const modeLabel = (mode) => normalizeMode(mode) === "trabajador" ? "Trabajador" : "Cliente";

const ClientAccessModal = ({onClose, setScreen}) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:900,display:"flex",alignItems:"center",justifyContent:"center",padding:18}}>
    <div style={{background:C.surface,borderRadius:24,maxWidth:420,width:"100%",padding:24,boxShadow:"0 18px 60px rgba(0,0,0,.25)",position:"relative"}}>
      <button onClick={onClose} style={{position:"absolute",top:14,right:14,background:C.faint,border:"none",borderRadius:10,width:36,height:36,cursor:"pointer",fontSize:18,color:C.sub}}>×</button>
      <div style={{textAlign:"center",padding:"8px 6px 0"}}>
        <div style={{fontSize:38,marginBottom:8}}>🏠</div>
        <div style={{fontFamily:"Georgia, serif",fontSize:28,fontWeight:900,color:C.text,marginBottom:6}}>Cliente</div>
        <div style={{color:C.sub,fontSize:13,lineHeight:1.55,marginBottom:18}}>Inicia sesión para buscar maestros, ver perfiles completos, solicitar cotizaciones y contactar por WhatsApp.</div>
        <div style={{height:1,background:C.divider,margin:"0 0 18px"}}/>
        <div style={{fontSize:12,fontWeight:900,color:C.text,marginBottom:10}}>Iniciar sesión como cliente</div>
        <Btn full color={C.accent} onClick={()=>{onClose();setScreen("cliente-login");}}>👤 Iniciar sesión</Btn>
        <div style={{height:10}}/>
        <Btn full outline color={C.accent} onClick={()=>{onClose();setScreen("reg-client");}}>Crear cuenta</Btn>
        <div style={{display:"flex",justifyContent:"center",gap:8,marginTop:18,fontSize:13,color:C.sub}}>
          <span>¿Eres trabajador?</span>
          <button onClick={()=>{onClose();setScreen("reg-worker");}} style={{border:"none",background:"transparent",color:C.blue,fontWeight:900,cursor:"pointer"}}>Regístrate aquí</button>
        </div>
      </div>
    </div>
  </div>
);

const WorkerAccessModal = ({onClose, setScreen}) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:900,display:"flex",alignItems:"center",justifyContent:"center",padding:18}}>
    <div style={{background:C.surface,borderRadius:24,maxWidth:420,width:"100%",padding:24,boxShadow:"0 18px 60px rgba(0,0,0,.25)",position:"relative"}}>
      <button onClick={onClose} style={{position:"absolute",top:14,right:14,background:C.faint,border:"none",borderRadius:10,width:36,height:36,cursor:"pointer",fontSize:18,color:C.sub}}>×</button>
      <div style={{textAlign:"center",padding:"8px 6px 0"}}>
        <div style={{fontSize:38,marginBottom:8}}>🔨</div>
        <div style={{fontFamily:"Georgia, serif",fontSize:28,fontWeight:900,color:C.text,marginBottom:6}}>Trabajador</div>
        <div style={{color:C.sub,fontSize:13,lineHeight:1.55,marginBottom:18}}>Inicia sesión para revisar tus solicitudes, administrar tus trabajos y mantener tu perfil activo en FICIO.</div>
        <div style={{height:1,background:C.divider,margin:"0 0 18px"}}/>
        <div style={{fontSize:12,fontWeight:900,color:C.text,marginBottom:10}}>Acceso para trabajador</div>
        <Btn full color={C.accent} onClick={()=>{onClose();setScreen("worker-login");}}>👤 Iniciar sesión</Btn>
        <div style={{height:10}}/>
        <Btn full outline color={C.accent} onClick={()=>{
          onClose();
          setScreen("reg-worker");
        }}>Crear cuenta</Btn>
        <div style={{display:"flex",justifyContent:"center",gap:8,marginTop:18,fontSize:13,color:C.sub}}>
          <span>¿Eres cliente?</span>
          <button onClick={()=>{onClose();setScreen("reg-client");}} style={{border:"none",background:"transparent",color:C.blue,fontWeight:900,cursor:"pointer"}}>Crear cuenta de cliente</button>
        </div>
      </div>
    </div>
  </div>
);

export const Landing = ({setScreen, user, profile, activeMode, setActiveMode, directoryData}) => {
  // FIX E2: usar la misma fuente que el Directorio — directoryData.workers del estado global
  const totalMaestros = (directoryData?.workers || []).length || 0;
  const [showClientAccess, setShowClientAccess] = useState(false);
  const [showWorkerAccess, setShowWorkerAccess] = useState(false);
  const hasSession = Boolean(user?.id);
  return (
  <div style={{minHeight:"100vh",background:C.bg,paddingBottom:80}}>
    <div style={{maxWidth:640,margin:"0 auto",padding:"0 20px"}}>
      <div style={{padding:"24px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:28}}>
        <div>
          <div style={{fontFamily:"'Georgia',serif",fontSize:36,fontWeight:900,color:C.text,letterSpacing:-1,lineHeight:1}}>FI<span style={{color:C.accent}}>CI</span>O</div>

        </div>
        <button onClick={()=>hasSession ? setScreen("cuenta") : setShowClientAccess(true)} style={{background:hasSession?C.surface:C.accent,border:hasSession?`1.5px solid ${C.border}`:"none",color:hasSession?C.text:"#fff",borderRadius:12,padding:"10px 18px",fontSize:13,fontWeight:800,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",boxShadow:hasSession?"0 2px 8px rgba(0,0,0,.06)":`0 4px 12px ${C.accent}40`}}>
          {hasSession ? `${getUserDisplayName(user, profile)} · ${modeLabel(activeMode)}` : "+ Registrarme"}
        </button>
      </div>

      <div style={{background:`linear-gradient(135deg,${C.accent},${C.accentD})`,borderRadius:24,padding:"28px 24px",marginBottom:20,position:"relative",overflow:"hidden",boxShadow:`0 8px 32px ${C.accent}40`}}>
        <div style={{position:"absolute",top:-20,right:-20,width:100,height:100,borderRadius:"50%",background:"rgba(255,255,255,0.1)"}}/>

        <div style={{fontFamily:"'Georgia',serif",fontSize:26,fontWeight:800,color:"#fff",lineHeight:1.2,marginBottom:14}}>Encuentra al maestro que necesitas hoy</div>
        <div style={{color:"rgba(255,255,255,0.85)",fontSize:13,lineHeight:1.6,marginBottom:20}}>Trabajadores verificados · Reputación real · Respaldo ante accidentes</div>
        <button onClick={()=>{ if(user){ setActiveMode("cliente"); setScreen("directory"); } else setShowClientAccess(true); }}
          style={{background:"#fff",border:"3px solid #fff",color:C.accent,borderRadius:14,padding:"16px 32px",fontWeight:900,fontSize:17,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",boxShadow:"0 6px 24px rgba(0,0,0,0.25)",letterSpacing:0.3,display:"inline-flex",alignItems:"center",gap:10,transition:"all 0.2s"}}
          onMouseEnter={e=>{e.currentTarget.style.transform="scale(1.05)";e.currentTarget.style.boxShadow="0 10px 32px rgba(0,0,0,0.35)";}}
          onMouseLeave={e=>{e.currentTarget.style.transform="scale(1)";e.currentTarget.style.boxShadow="0 6px 24px rgba(0,0,0,0.25)";}}>
          🔍 Buscar un maestro
        </button>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:20}}>
        {[{n:"19",l:"Oficios",icon:"🔨"},{n:totalMaestros > 0 ? totalMaestros.toString() : "0",l:"Maestros",icon:"👷"},{n:"$499",l:"Supervisión",icon:"🏗️"}].map(s=>(
          <div key={s.l} style={{background:C.surface,borderRadius:16,padding:"16px 10px",textAlign:"center",border:`1px solid ${C.border}`,boxShadow:"0 2px 8px rgba(0,0,0,0.04)"}}>
            <div style={{fontSize:20,marginBottom:4}}>{s.icon}</div>
            <div style={{fontFamily:"'Georgia',serif",fontSize:20,fontWeight:800,color:C.accent}}>{s.n}</div>
            <div style={{color:C.muted,fontSize:11,marginTop:2}}>{s.l}</div>
          </div>
        ))}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:20}}>
        {[{s:"worker-access",icon:"🔨",title:"Soy Trabajador",desc:"Inicia sesión o crea tu cuenta",color:C.accent},{s:"client-access",icon:"🏠",title:"Soy Cliente",desc:"Encuentra al maestro ideal",color:C.blue}].map(r=>(
          <div key={r.s} onClick={()=>{
            if (r.s==="client-access") { if(user){ setActiveMode("cliente"); return setScreen("obra-activa"); } return setShowClientAccess(true); }
            if (r.s==="worker-access") { if(user){ setActiveMode("trabajador"); return setScreen("obra-activa"); } return setShowWorkerAccess(true); }
            setScreen(r.s);
          }} style={{background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:18,padding:"18px 14px",cursor:"pointer",boxShadow:"0 2px 8px rgba(0,0,0,0.04)",transition:"all 0.2s",display:"flex",alignItems:"center",gap:12}}
            onMouseEnter={e=>{e.currentTarget.style.borderColor=r.color;e.currentTarget.style.boxShadow=`0 6px 20px ${r.color}20`;}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,0.04)";}}>
            <div style={{fontSize:28}}>{r.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontFamily:"'Georgia',serif",fontSize:15,fontWeight:800,color:C.text,marginBottom:4}}>{r.title}</div>
              <div style={{color:C.muted,fontSize:12,lineHeight:1.4}}>{r.desc}</div>
            </div>
            <div style={{fontSize:22,color:r.color}}>›</div>
          </div>
        ))}
      </div>

      {/* Supervisor card */}
      <div onClick={()=>setScreen("reg-supervisor")} style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:18,padding:"16px 18px",cursor:"pointer",display:"flex",alignItems:"center",gap:14,marginBottom:20,boxShadow:"0 2px 8px rgba(0,0,0,0.04)",transition:"all 0.2s"}}
        onMouseEnter={e=>{e.currentTarget.style.borderColor=C.blue;e.currentTarget.style.boxShadow=`0 6px 20px ${C.blue}20`;}}
        onMouseLeave={e=>{e.currentTarget.style.borderColor=`${C.blue}30`;e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,0.04)";}}>
        <div style={{width:50,height:50,borderRadius:14,background:`linear-gradient(135deg,${C.blue},#0C447C)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,flexShrink:0,boxShadow:`0 4px 12px ${C.blue}40`}}>🏗️</div>
        <div style={{flex:1}}>
          <div style={{color:C.blue,fontSize:10,fontWeight:800,letterSpacing:1.2,textTransform:"uppercase",marginBottom:2}}>Ing. / Arq. con cédula SEP</div>
          <div style={{fontFamily:"'Georgia',serif",fontSize:16,fontWeight:800,color:C.text}}>Soy Supervisor Profesional</div>
          <div style={{color:C.sub,fontSize:12}}>Gana $349 por cada visita de supervisión · Sin cuota mensual</div>
        </div>
        <div style={{color:C.blue,fontSize:22}}>›</div>
      </div>


      <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
        {["✓ Perfiles verificados","✓ Reputación bidireccional","✓ Fondo de contingencia","✓ Supervisión $500","✓ Gestión de obra"].map(t=>(
          <span key={t} style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:20,padding:"6px 14px",fontSize:12,color:C.sub,fontWeight:500}}>{t}</span>
        ))}
      </div>

    </div>
    {showClientAccess && <ClientAccessModal setScreen={setScreen} onClose={()=>setShowClientAccess(false)}/>}
    {showWorkerAccess && <WorkerAccessModal setScreen={setScreen} onClose={()=>setShowWorkerAccess(false)}/>}
  </div>
  );
};
